import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { ComputersAndVirtualMachinesBaseDataProvider } from '../dataProvider/ComputersAndVirtualMachinesBaseDataProvider';

export class ComputersAndVirtualMachinesDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, ComputersAndVirtualMachinesBaseDataProvider);
  }
}
